import { useMutation, useQuery } from "@tanstack/react-query";
import { PlanDto, SubscriptionPlanDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { PlanClient } from "../../../services/proxies";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace PlanService {
  const planClient = new PlanClient();

  export const save = () =>
    useMutation<IActionResult<PlanDto>, Error, PlanDto>({
      mutationFn: async (payload: PlanDto) =>
        await planClient.savePlanAsync(payload),
    });

  export const getPlanQuery = (planId: string | undefined) =>
    useQuery({
      queryKey: ["planQuery", planId],
      queryFn: async () => await planClient.getPlanAsync(planId),
      enabled: Boolean(planId && planId !== Constants.emptyGuid),
    });

  export const getPlansQuery = () =>
    useQuery({
      queryKey: ["plansQuery"],
      queryFn: async () => await planClient.getPlansAsync(),
    });

  export const gridQuery = (searchQuery: SearchDto) =>
    useQuery({
      queryKey: ["planGridQuery", searchQuery],
      queryFn: async () => await planClient.searchPlansAsync(searchQuery),
    });

  export const deActivatePlan = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (planId: string | undefined) =>
        await planClient.deActivatePlanAsync(planId),
    });

  export const saveSubscriptionPlan = () =>
    useMutation<IActionResult<SubscriptionPlanDto>, Error, SubscriptionPlanDto>(
      {
        mutationFn: async (payload: SubscriptionPlanDto) =>
          await planClient.saveSubscriptionPlanAsync(payload),
      }
    );

  export const gridSubscriptionPlanQuery = (searchQuery: SearchDto) =>
    useQuery({
      queryKey: ["subscriptionPlanGridQuery", searchQuery],
      queryFn: async () =>
        await planClient.searchSubscriptionPlanAsync(searchQuery),
    });

  export const deActivateSubscriptionPlan = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) =>
        await planClient.deActivateSubscriptionPlanAsync(id),
    });
}
